import classNames from 'classnames'
import useEmblaCarousel from 'embla-carousel-react'
import { EmblaCarouselType } from 'embla-carousel'
import { useEffect, forwardRef, useImperativeHandle } from 'react'
import { Carousel } from '../../../components/Carousel'
import { Image } from '../../../components/Image'
import { ImageCarouselProps } from '../types'
import { useProductCardContext } from '../ProductCard'
import { ArrowLeft, ArrowRight } from './Arrow'

export const ImageCarousel = forwardRef<
  EmblaCarouselType | undefined,
  ImageCarouselProps
>(({ children, className, images = [], ...props }, ref) => {
  const { href } = useProductCardContext()
  const [emblaRef, embla] = useEmblaCarousel(
    {
      align: 'center',
      containScroll: 'trimSnaps',
      skipSnaps: true,
      loop: true,
      active: images.length > 1,
    },
    [],
  )

  useImperativeHandle(ref, () => embla)

  useEffect(() => embla?.reInit(), [images.length])

  return (
    <a
      href={href}
      className={classNames('product-card__image group', className)}
      draggable={false}
      {...props}
    >
      {images.length > 0 && (
        <Carousel emblaRef={emblaRef} embla={embla}>
          <ArrowLeft />
          <Carousel.Viewport>
            <Carousel.Container className="auto-cols-[100%] h-full">
              {images.map((image, index) => (
                <Carousel.Slide
                  key={index}
                  index={index}
                  lazyload
                  lazyloadThreshold={0}
                  inViewThreshold={0}
                >
                  <Image {...image} />
                </Carousel.Slide>
              ))}
            </Carousel.Container>
          </Carousel.Viewport>
          <ArrowRight />
        </Carousel>
      )}
    </a>
  )
})

ImageCarousel.displayName = 'ImageCarousel'
